const EvCharging_Icon = ({ className = "" }) => {
  return (
    <svg 
      width="12" 
      height="12" 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
    <path 
      d="M21.6 14.9L17.5 14.3L21.3 6.5C21.4 6.3 21.3 6 21 6L14.2 6.1C14.1 6.1 14 6.2 13.9 6.3C13.9 6.3 10.1 15.8 9.90005 16.2C9.70005 16.6 10 17.3 10.5 17.4L14.9 18.1L13.1 26C13 26.3 13.5 26.4 13.6 26.2L22 15.8C22.3 15.5 22.1 15 21.6 14.9Z" fill="#79C8B0"
    />
    <path 
        d="M21.6 14.9L17.5 14.3L21.3 6.5C21.4 6.3 21.3 6 21 6L14.2 6.1C14.1 6.1 14 6.2 13.9 6.3C13.9 6.3 10.1 15.8 9.90005 16.2C9.70005 16.6 10 17.3 10.5 17.4L14.9 18.1L13.1 26C13 26.3 13.5 26.4 13.6 26.2L22 15.8C22.3 15.5 22.1 15 21.6 14.9Z" fill="url(#paint0_linear_4261_63706)"
    />
    <path 
        d="M16.0001 1.09998C7.8001 1.09998 1.1001 7.79998 1.1001 16C1.1001 24.2 7.8001 30.9 16.0001 30.9C24.2001 30.9 30.9001 24.2 30.9001 16C30.9001 7.79998 24.2001 1.09998 16.0001 1.09998ZM16.0001 28.3C9.2001 28.3 3.7001 22.8 3.7001 16C3.7001 9.19998 9.2001 3.69998 16.0001 3.69998C22.8001 3.69998 28.3001 9.19998 28.3001 16C28.3001 22.8 22.8001 28.3 16.0001 28.3Z" fill="#79C8B0"
    />
    <path 
        d="M16.0001 1.09998C7.8001 1.09998 1.1001 7.79998 1.1001 16C1.1001 24.2 7.8001 30.9 16.0001 30.9C24.2001 30.9 30.9001 24.2 30.9001 16C30.9001 7.79998 24.2001 1.09998 16.0001 1.09998ZM16.0001 28.3C9.2001 28.3 3.7001 22.8 3.7001 16C3.7001 9.19998 9.2001 3.69998 16.0001 3.69998C22.8001 3.69998 28.3001 9.19998 28.3001 16C28.3001 22.8 22.8001 28.3 16.0001 28.3Z" fill="url(#paint1_linear_4261_63706)"
    />
    <defs>
        <linearGradient 
            id="paint0_linear_4261_63706" 
            x1="19.8341" 
            y1="22.92" 
            x2="9.63563" 
            y2="17.063" 
            gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FA37C"/>
          <stop offset="1" stop-color="#1FA37C" stop-opacity="0"/>
        </linearGradient>

        <linearGradient 
            id="paint1_linear_4261_63706" 
            x1="25.3126" 
            y1="25.9333" 
            x2="8.00793" 
            y2="9.53272" 
            gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FA37C"/>
          <stop offset="1" stop-color="#1FA37C" stop-opacity="0"/>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default EvCharging_Icon;
